import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/GetPartDateModified'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class GetPartDateModifiedStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "GetPartDateModifiedStore",
			variables: true,
		})
	}
}

export async function load_GetPartDateModified(params) {
  await initClient()

	const store = new GetPartDateModifiedStore()

	await store.fetch(params)

	return {
		GetPartDateModified: store,
	}
}
